import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";
import { queryKeys } from "../api/queryKeys";

interface Category {
  cod_type: string;
  type?: string;
  group: string;
  category: string;
}

export const useCategories = () => {
  return useQuery<Category[]>({
    queryKey: queryKeys.categories,
    queryFn: async () => {
      const response = await api.get("products/categories");
      return response.data;
    },
    staleTime: 15 * 60 * 1000, // 15 minutos
  });
};
